import React from 'react';
import {DescriptionUpdateTask} from '@/components/NotificationDrawer/components/NotificationItem/components/UpdateTask';
import {DescriptionSharedFile} from '@/components/NotificationDrawer/components/NotificationItem/components/SharedFile';

// eslint-disable-next-line react/display-name
export default (notification) => {
  switch (notification?.type) {
    case 'TASK_UPDATE_STATE':
      return <DescriptionUpdateTask item={notification}/>;
    case 'SHARE_FILE':
      return <DescriptionSharedFile item={notification}/>;
    default:
      // eslint-disable-next-line
      return () => null;
  }
};